module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0),
      expression: "items.length > 0"
    }]
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.t('Shop')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.t('Seller')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.t('Name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Count of occurs as price leader')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('td', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.seller_name),
        expression: "item.seller_name"
      }]
    }, [_vm._v(_vm._s(item.seller_name))])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank",
        "rel": "noreferrer"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.price_leader_count))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-025fdc54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheapestShops.vue
// module id = 1222
// module chunks = 2